export default __webpack_public_path__ + "static/fall16-71099e069b0117be750a414e8f6c3fc4.webp";